__webpack_require__.p = "/applications/jtp/";